module.exports = __webpack_public_path__ + "static/media/Panel_L.a6bed6f9.png";